$(window).on('load', () => {
  var i = 30;
  var ivt = setInterval(() => {
    if ($('.template-product .gfgUnifiedDiscountWrapper > .gfgCustomDiscountWrapper').length >= 1
      && $('.template-product .gfgUnifiedDiscountWrapper > .gfgCustomDiscountWrapper').text().trim() != '') {
      clearInterval(ivt);

      var title = typeof langify !== 'undefined' && langify.locale.iso_code == 'zh-TW' ? '優惠價加購以下指定產品：' : 'Add-on Offer:';
      $('.template-product .gfgPageWrapper.gfgUnifiedDiscountWrapper > strong').remove();
      $('.template-product .gfgPageWrapper.gfgUnifiedDiscountWrapper').prepend(`<strong>${title}</strong>`);

      $('.template-product .gfgUnifiedDiscountWrapper > .gfgCustomDiscountWrapper, .gfgCustomDiscountSideCartWrapperV4').each(function() {
        const slider = this;
        const $slider = $(slider);
        const isSideCartSlider = $slider.hasClass('gfgCustomDiscountSideCartWrapperV4');
        let $wrapper = $slider.parent();
        const isZhTw = typeof langify !== 'undefined' && langify.locale.iso_code == 'zh-TW';

        if (isSideCartSlider && !$wrapper.hasClass('kite-slider-nav-wrapper')) {
          $slider.wrap('<div class="kite-slider-nav-wrapper"></div>');
          $wrapper = $slider.parent();
        } else {
          $wrapper.addClass('kite-slider-nav-wrapper');
        }

        if ($wrapper.children('.kite-slider-nav').length) return;

        const $prevButton = $(`<button class="kite-slider-nav kite-slider-nav--prev icon icon-angle-left" type="button">
        </button>`);
        const $nextButton = $(`<button class="kite-slider-nav kite-slider-nav--next icon icon-angle-right" type="button">
        </button>`);

        $wrapper.append($prevButton, $nextButton);

        function getScrollStep() {
          const cards = slider.children;

          if (cards.length > 1) {
            return cards[1].offsetLeft - cards[0].offsetLeft;
          }

          return Math.max(slider.clientWidth * 0.8, 1);
        }

        function updateSliderNav() {
          const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
          const hasOverflow = maxScrollLeft > 1;

          $prevButton.toggle(hasOverflow).prop('disabled', slider.scrollLeft <= 1);
          $nextButton.toggle(hasOverflow).prop('disabled', slider.scrollLeft >= maxScrollLeft - 1);
        }

        $prevButton.on('click', function() {
          slider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
        });

        $nextButton.on('click', function() {
          slider.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
        });

        $slider.on('scroll', updateSliderNav);
        $(window).on('resize', updateSliderNav);
        updateSliderNav();
      });

      // $(window).on('resize', updateKiteAppWidth);
      // setTimeout(function() {
      //   updateKiteAppWidth();
      // }, 100);
      // function updateKiteAppWidth() {
      //   let s = $('.gfgUnifiedDiscountWrapper > .gfgCustomDiscountWrapper');
      //   s.removeAttr('style');

      //   let w = $('body').width();
      //   let c_w = $('.product-details-container').outerWidth();
      //   let s_w = s.outerWidth();
      //   s.css({
      //     width: `${s_w + ((w - c_w) / 2)}px`,
      //   });
      // }
    }
    i--;
    if (i < 0) clearInterval(ivt);
  }, 1000);

  if ($('.template-product .gfgBuyXGetYCustomDiscountAccordionBody > .gfgBuyXGetYProductListWrapper').length >= 1) {
    // $(window).on('resize', updateKiteAppWidth);
    // setTimeout(function() {
    //   updateKiteAppWidth();
    // }, 100);
    // function updateKiteAppWidth() {
    //   let s = $('.gfgBuyXGetYCustomDiscountAccordionBody > .gfgBuyXGetYProductListWrapper');
    //   s.removeAttr('style');

    //   let w = $('body').width();
    //   let c_w = $('.product-details-wrapper').outerWidth();
    //   let s_w = s.outerWidth();
    //   s.css({
    //     // width: `${s_w + ((w - c_w) / 2)}px`,
    //     width: `${c_w}px`,
    //   });
    // }
  }

  $('div[class*="CustomDiscountAccordionAction"]').addClass('accordion-state-open')
    .prev().addClass('accordion-state-open');
});
